import Administrator from "./Administrator";
import SuperAgent from "./SuperAgent";

const UpdateComponent = {
  Administrator, 
  SuperAgent,
}

export default UpdateComponent;